import MaterialInvoiceTable from "../../../../../components/tables/MaterialInvoiceTable";
import { SubmittedActivityHistoryExpandedRow } from "./SubmittedActivityHistoryExpandedRow";

interface VendorInvoiceDetailsProps {
  activityHistoryData: any;
}

export const SubmittedInvoiceActivityHistoryView: React.FC<
  VendorInvoiceDetailsProps
> = ({ activityHistoryData }) => {
  const materialColumns = [
    {
      title: "Activity Description",
      field: "activity",
      width: "14%",
    },
    {
      title: "Service No. Account",
      field: "accountNumber",
      width: "10%",
      sorting: false,
    },
    { title: "Corporate Office No.", field: "storeNumber", width: "8%" },
    { title: "Amount Paid", field: "amountPaid", width: "8%" },
    { title: "Invoice No.", field: "invoiceNumber", width: "8%" },
    { title: "Modified By", field: "createdBy", width: "10%" },
    {
      title: "Modified Date",
      field: "createdDate",
      width: "10%",
      render: (row) => {
        return (
          <div className="w-full">
            {row.createdDate
              ? new Date(row.createdDate).toLocaleDateString().split("T")[0]
              : "Unspecified"}
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div className="bg-white border rounded-md">
        <div className="overflow-x-auto grid grid-row">
          <MaterialInvoiceTable
            columns={materialColumns}
            data={activityHistoryData}
            isLoading={false}
            options={{
              pageSize: 3,
              toolbar: false,
              showTitle: false,
              exportButton: false,

              search: true,
              headerStyle: {
                backgroundColor: "#FAFEFF",
                color: "#5A5959",
                fontWeight: "bold",
                fontSize: "12px",
              },
              rowStyle: {
                backgroundColor: "#FFFFFF",
                color: "#333333",
                fontSize: "12px",
              },
            }}
            detailpanel={(rowdata) => {
              return <SubmittedActivityHistoryExpandedRow rowData={rowdata} />;
            }}
          />
        </div>
      </div>
    </>
  );
};
